<template>
   <header>
      <div class="topbar d-flex align-items-center">
         <nav class="navbar navbar-expand">
            <button v-if="mobile" type="button" class="mobile-toggle-menu" aria-label="Alternar menu lateral" title="Alternar menu lateral" :aria-expanded="String(menuOpen)" @click="$emit('toggle-menu')"><i class='bx bx-menu' aria-hidden="true"></i></button>
            <div class="conta-navbar-wrapper flex-grow-1">
               <div class="conta-navbar" :title="[nomeConta, detalhesConta].filter(Boolean).join(' · ')" :aria-busy="String(carregandoConta)">
                  <p class="empresa-nome mb-0">{{ nomeConta }}</p>
                  <p v-if="detalhesConta" class="empresa-cnpj mb-0">{{ detalhesConta }}</p>
                  <p v-else-if="carregandoConta" class="empresa-cnpj mb-0" role="status">Carregando dados da conta...</p>
                  <p v-else-if="erroConta" class="empresa-cnpj mb-0" role="status">Dados da conta indisponíveis.</p>
               </div>
            </div>
            <div class="user-box dropdown user-box-compact">
               <a class="d-flex align-items-center nav-link dropdown-toggle dropdown-toggle-nocaret" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false" :title="dadosUsuario.contactName || 'Perfil do usuário'">
                  <img :src="avatarUsuario" @error="imageError" class="user-img border-theme border-2" ref="avatar" alt="Foto do usuário">
                  <div class="user-info ps-12">
                     <p class="user-name mb-0">{{ primeiroNomeUsuario }}</p>
                  </div>
               </a>
               <ul class="dropdown-menu dropdown-menu-end">
                  <li><a class="dropdown-item" href="javascript:;" @click="abrirPerfil"><i class='bx bx-user'></i><span>Perfil</span></a></li>
                  <li><a class="dropdown-item" href="javascript:;" @click="deslogar"><i class='bx bx-log-out-circle'></i><span>Deslogar</span></a></li>
               </ul>
            </div>
            <button type="button" class="btn topbar-logout-shortcut" title="Sair do sistema" aria-label="Sair do sistema" @click="deslogar"><i class="bx bx-log-out-circle" aria-hidden="true"></i></button>
         </nav>
      </div>
   </header>
</template>

<script>

import { mapState } from 'vuex'
import avatarPadrao from '@/assets/images/avatar.png'
import { urlArquivoPublico } from '@/services/arquivoPublico'

export default {
	name: 'MenuNavBar',
   props: { menuOpen: Boolean, mobile: Boolean },
   data() { return { avatarPadrao, perfilConta: null, carregandoConta: false, erroConta: false } },
   computed: {
      primeiroNomeUsuario() { return String(this.dadosUsuario.contactName || '').trim().split(/\s+/)[0] || 'Usuário' },
      avatarUsuario() { return urlArquivoPublico(this.dadosUsuario.avatar, this.urlRest) || avatarPadrao },
      identidadeConta() { return `${this.dadosUsuario?.entityType || ''}:${this.dadosUsuario?.id || ''}` },
      nomeConta() {
         return this.perfilConta?.basicData?.businessName || this.dadosUsuario?.basicData?.businessName ||
            this.perfilConta?.basicData?.tradeName || this.dadosUsuario?.businessName ||
            this.dadosUsuario?.contactName || 'Conta acessada'
      },
      detalhesConta() {
         const dados = this.perfilConta || this.dadosUsuario || {}
         const basicData = dados.basicData || dados
         const documento = String(basicData.cnpj || '').trim()
         const digitos = documento.replace(/\D/g, '')
         const cnpj = /^\d{14}$/.test(digitos) ? digitos.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5') : documento
         const localizacao = [dados.address?.city, dados.address?.state].filter(Boolean).join(' - ')
         return [cnpj ? cnpj : '', basicData.stateRegistration ? `IE: ${basicData.stateRegistration}` : '', localizacao].filter(Boolean).join(' | ')
      },
      ... mapState({
         dadosUsuario: state => state.dadosUsuario,
         urlRest: state => state.urlRest
      })
   },
   watch: {
      identidadeConta: { immediate: true, handler: 'carregarConta' },
      $route(to, from) { if (from.path === '/perfil' && to.path !== '/perfil') this.carregarConta() }
   },
   methods: {
      async carregarConta() {
         const identidade = this.identidadeConta
         this.perfilConta = null
         this.erroConta = false
         this.carregandoConta = false
         if (!this.dadosUsuario?.id) return
         const entidade = this.dadosUsuario.entityType === 'Proprietário da Conta' ? 'account' : 'representative'
         this.carregandoConta = true
         try {
            const response = await this.$axios({ method: 'get', url: `${this.urlRest}gerencial/${entidade}/${this.dadosUsuario.id}` })
            if (!this._isDestroyed && identidade === this.identidadeConta) this.perfilConta = response.data
         } catch (error) {
            if (!this._isDestroyed && identidade === this.identidadeConta) this.erroConta = true
         } finally {
            if (!this._isDestroyed && identidade === this.identidadeConta) this.carregandoConta = false
         }
      },
      imageError : function (e) {
         this.$store.dispatch('imageError', e)
      },
      deslogar : function () {
			this.$store.dispatch('deslogar')
      },
      abrirPerfil : function () {
         if (this.$route.path !== '/perfil') { this.$router.push('/perfil').catch(() => {}) }
      }
   }
}

</script>
